import { useQuery } from '@tanstack/react-query';

import { fetchData } from '@/lib/fetch';
import type { News } from '../types';
import { selectNews } from '../utils';

/** Item cap used by front-page teasers (dashboard, "unread" modal); the full news page omits `limit`. */
export const NEWS_TEASER_LIMIT = 3;

/** Pass a `limit` for a capped teaser (e.g. front page); omit it for the full, reverse-chronological list. */
export const useGetNews = (limit?: number) =>
  useQuery({
    queryKey: ['news'],
    queryFn: () =>
      fetchData({
        endpoint: 'docs/news.json',
        options: { headers: { 'Cache-Control': 'no-cache,no-store' } },
      }),
    select: (data: Array<News>) => selectNews(data, limit),
  });
